export default "__VITE_ASSET__CtTHwNlQ__"